export const clearEstabPrice = () => {
    return typeof window !== 'undefined' && window.localStorage.removeItem('EstabPrice');
};
export function setEstabPrice(record) {
    if (record && typeof window !== 'undefined') {
        clearEstabPrice();
        window.localStorage.setItem('EstabPrice', JSON.stringify(record));
    }
}
export const getEstabPrice = () => {
    if (typeof window === 'undefined')
        return undefined;
    const localStorageItem = window.localStorage.getItem('EstabPrice');
    try {
        if (localStorageItem) {
            return JSON.parse(localStorageItem);
        }
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to parse localStorageItem:', error);
    }
    return undefined;
};
